var map = {
	"./accordion.svg": 29965,
	"./collapse.svg": 22765,
	"./dashboard.svg": 77553,
	"./eye.svg": 45564,
	"./eye_slash.svg": 87322,
	"./home.svg": 32520,
	"./loading.svg": 60659,
	"./menu-fold.svg": 30790,
	"./menu-unfold.svg": 73075,
	"./menu.svg": 85674,
	"./search.svg": 79262,
	"./setting.svg": 44932,
	"./warn.svg": 93958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88091;